import { Injectable } from '@angular/core';
import { PreferencesService } from '../../api/services/preferences.service';
import { AuthService } from '../../api/services/auth.service';
import { UserService } from '../../api/services/user.service';
import { FileUploadService } from '../../api/services/file-upload.service';
import { Subject } from 'rxjs/Subject';
import { of } from 'rxjs/observable/of';

@Injectable()
export class ClientLogoService {

  constructor(private userService: UserService,
              private authService: AuthService,
              private preferencesService: PreferencesService,
              private fileUploadService: FileUploadService
            ) { }

  clientLogoObserver = new Subject<string>();

  getLogoImage() {
    this.userService.findUserById(this.authService.getUserId())
    .switchMap(user => this.preferencesService.getPreferences('CUSTOMER', user['Organization ID']))
    .switchMap(prefs => {
      const logoId = prefs['organization-logo'].Value;

      return logoId? this.fileUploadService.get(logoId) : of({url: ''});
    })
    .map(image => {
      this.clientLogoObserver.next(image.url);
    })
    .subscribe();
  }

  getClientLogo() {
    setTimeout(() => this.getLogoImage(), 0);

    return this.clientLogoObserver;
  }

  refreshClientLogo() {
    this.getLogoImage();
  }


}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/services/client-logo.service.ts